import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { TipoArticolo } from '../../../models/TipoArticolo';
import { ArticoloService } from './../../../services/articolo.service';

@Component({
  selector: 'app-tipo-articolo-selector',
  templateUrl: './tipo-articolo-selector.component.html',
  styleUrls: ['./tipo-articolo-selector.component.css'],
  providers: [
    ArticoloService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TipoArticoloSelectorComponent),
      multi: true
    }
  ]
})
export class TipoArticoloSelectorComponent implements OnInit {
  items: Observable<any[]>;
  selected: TipoArticolo;
  loading: boolean;

  @Input() list: string;
  @Input() placeholder: string;
  @Input() required: boolean = false;
  @Output() notify: EventEmitter<TipoArticolo> = new EventEmitter<TipoArticolo>();

  @Input() eraseable: boolean;
  @Output() removeNotify: EventEmitter<any> = new EventEmitter<any>();


  constructor(private service: ArticoloService) { }

  onChange(e: TipoArticolo) {
    this.notify.emit(e)
    this.propagateChange(e);
  }

  compareWithFn = function(o1: TipoArticolo, o2: TipoArticolo) {
    let match = o1 && o2 ? o1.codice == o2.codice : false;
    if (match) {
      if (this.notify) {
        this.notify.emit(o1);
      }
    }
    return match;
  }.bind(this);

  ngOnInit() {
    this.loading = true;
    this.items = this.service.readTipiArticoli().map(result => {
      this.loading = false;
      if (result.success) {
        return result.items;
      }
    })
  }

  eraseMe() {
    this.removeNotify.emit();
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: TipoArticolo) {
    if (obj) {
      this.selected = new TipoArticolo({
        codice: obj.codice,
        descrizione: obj.descrizione,
        testata: {
          codice: '05',
          descrizione: 'Testimoni'
        }
      })

      // this.selected = new TipoArticolo();
      // this.selected.codice = obj.codice;
      // this.selected.descrizione = obj.descrizione;
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/articolo/tipo-articolo-selector/tipo-articolo-selector.component.ts